/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  grupo_tipo_actividad: [],
  tipo_actividad: [],
  tipo_actividad_externa: [],
  sub_proyecto: [],
  proyecto: [],
  servicios: [],
  criticality: [],
  itil_incident_type: [],
  applicative: [],
  help_desk: [],
  ges_activos: [],
  area_by_resource: [],
  companies: [],
  resource_by_project: [],
  servicetype_by_casetype: [],
  criticality_by_casetype: [],
  project_add_data: [],
  projectId_add_data: [],
  source_request: [],
  request_class: [],
  accounts: [],
  meta: [],
  tiposCuenta: [],
  tiposIdentificacion: [],
  business_unit: [],
}
